import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=05289855&"
import script from "./Community.vue?vue&type=script&lang=js&"
export * from "./Community.vue?vue&type=script&lang=js&"
import style0 from "./Community.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports